import React, { useEffect, useState } from "react";
import { json, useLocation, useNavigate } from "react-router-dom";
import "./SingleProduct.css";
import { productsUrl } from "../../api";
import { useRef } from "react";
import { toast } from "react-toastify";
const SingleProduct = () => {
  const [data, setData] = useState({});
  const location = useLocation();
  const history = useNavigate();
  const [bookState, setBookState] = useState({
    availableQuantity: "",
    categories: [],
    coverImage: "",
    currentPrice: 0,
    description: "",
    popularityIndex: 0,
    previousPrice: 0,
    title: "",
  });
  const title = useRef();
  const currentPrice = useRef();
  const previousPrice = useRef();
  const author = useRef();
  const [availableDrops, setAvailableDrops] = useState([]);

  useEffect(() => {
    fetch('https://backend.cdp3d.com/api/drops')
      .then(res => res.json())
      .then(data => setAvailableDrops(data))
      .catch(err => console.error(err));
  }, []);

  const bookId = location.pathname.split("/")[2];
  const url = `${productsUrl}${bookId}`;
  useEffect(() => {
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setBookState({
          ...data.data,
        });
      })
      .catch(() => {
        // toast.error("Error fetching data");
      });
  }, []);
  useEffect(() => {
    // restore scroll
    window.scrollTo(0, 0);
  });

  const changeData = (name, value) => {
    setBookState((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const EditBook = async () => {
    fetch(productsUrl + bookId, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title: bookState.title,
        currentPrice: bookState.currentPrice,
        previousPrice: bookState.previousPrice,
        additionalDetails: bookState.additionalDetails,
        dropId: bookState.dropId || null,
        description: bookState.description
      }),
    })
      .then((res) => {
        toast.success("Product Updated Successfully");
        history("/products");
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });

  };
  
  const deleteProduct = async (id) => {
    try {
      const response = await fetch(`${productsUrl}${id}`, {
        method: "DELETE",
      });
      if (response.ok) {
        toast.success("Product deleted successfully");
        history("/products");
      } else {
        toast.error("Failed to delete product");
      }
    } catch (error) {
      toast.error("An error occurred while deleting the product");
    }
  };

  return (
    <div className="content-wrapper">
      <div className="ImageContainer ">
        <img className="img-fluid" src={data.coverImage?.startsWith('/') ? `https://backend.cdp3d.com${data.coverImage}` : data.coverImage} alt={data.title} />
      </div>
      <div className="mb-3">
        <label>3D Model:</label>
        {data.modelUrl ? <a href={`https://backend.cdp3d.com${data.modelUrl}`} target="_blank" rel="noreferrer">View Current Model</a> : "No Model Uploaded"}
      </div>
      <div className="textContainer">
        <div>
          <label htmlFor="title">Title: </label>
          <input
            value={bookState.title || ""}
            onChange={(e) => changeData("title", e.target.value)}
            id="title"
            name="title"
            className="form-control"
          />
        </div>

        <div>
          <label htmlFor="author">Designer / Creator : </label>
          <input
            value={bookState.additionalDetails?.author || ""}
            onChange={(e) => {
              setBookState(prev => ({
                ...prev,
                additionalDetails: { ...prev.additionalDetails, author: e.target.value }
              }));
            }}
            id="author"
            name="author"
            className="form-control"
          />
        </div>

        <div>
          <label htmlFor="currentPrice">Current Price: </label>
          <input
            value={bookState.currentPrice || 0}
            onChange={(e) => changeData("currentPrice", e.target.value)}
            id="currentPrice"
            name="currentPrice"
            className="form-control"
          />
        </div>
        <div>
          <label htmlFor="previousPrice">Previous Price: </label>
          <input
            value={bookState.previousPrice || 0}
            onChange={(e) => changeData("previousPrice", e.target.value)}
            id="previousPrice"
            name="previousPrice"
            className="form-control"
          />
        </div>

        <div>
          <label>Assign to Drop: </label>
          <select
            value={bookState.dropId || ""}
            onChange={(e) => changeData("dropId", e.target.value)}
            className="form-control"
          >
            <option value="">None</option>
            {availableDrops.map(drop => (
              <option key={drop._id} value={drop._id}>{drop.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="description">Description: </label>
          <textarea
            value={bookState.description || ""}
            onChange={(e) => changeData("description", e.target.value)}
            id="description"
            name="description"
            className="form-control"
            rows="5"
          />
        </div>
      </div>

      <div className="button-container">
        <button className="btn btn-primary" onClick={EditBook}>
          Save
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            deleteProduct(bookId);
          }}
        >
          <i className="bi bi-trash"></i>
          Delete
        </button>
      </div>
    </div>
  );
};

export default SingleProduct;
